import { styled } from 'styled-components';
import { verticalFadeIn, verticalFadeOut } from '@/js/libs/ui/src/theme/animations';
import { ANIMATION_DURATION_MS } from './constants';
export const Wrapper = styled.div `
  z-index: ${({ zIndex }) => zIndex};
  ${({ theme }) => theme.shadows.large};
  border-radius: 8px;
  animation: ${({ isTop, visible }) => (visible ? verticalFadeIn(isTop) : verticalFadeOut(isTop))} ${ANIMATION_DURATION_MS}ms ease forwards;
  pointer-events: ${({ visible }) => (visible ? 'auto' : 'none')};
`;
export const InnerWrapper = styled.div `
  border-radius: 8px;
  list-style: none;
  background: ${({ theme }) => theme.colors.grey00_6};
  z-index: ${({ zIndex }) => zIndex};
  min-width: ${({ minWidth }) => minWidth && '160px'};
  overflow: hidden;
  position: relative;
`;
export const ButtonWrapper = styled.div `
  display: grid;
`;
